import React from 'react';
import { Save } from 'lucide-react';

interface SharkHeaderProps {
  onSave: () => void;
  isSaving: boolean;
}

export function SharkHeader({ onSave, isSaving }: SharkHeaderProps) {
  return (
    <div 
      className="shark-header-container"
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        flexWrap: 'wrap', 
        gap: '16px', 
        marginBottom: '24px' 
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h1 
          className="shark-header-title"
          style={{ 
            fontFamily: "'Space Grotesk', sans-serif",
            color: 'var(--admin-card-text)', 
            fontSize: '37.9px', 
            fontWeight: 700, 
            margin: '0 0 6px', 
            letterSpacing: '-0.76px',
            lineHeight: '38px'
          }}
        >
          Shark Settings
        </h1>
        <p 
          className="shark-header-desc"
          style={{ 
            fontFamily: "'Inter', sans-serif",
            color: '#7C8891', 
            fontSize: '14px', 
            margin: 0, 
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0'
          }}
        >
          Customize your autonomous sales assistant's identity.
        </p>
      </div>

      <button
        type="button"
        onClick={onSave}
        disabled={isSaving}
        className="shark-save-btn"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 16px',
          borderRadius: '0',
          backgroundColor: '#ffffff',
          color: '#000000',
          fontSize: '13px',
          fontWeight: 700,
          fontFamily: "'Inter', sans-serif",
          cursor: isSaving ? 'default' : 'pointer',
          border: 'none',
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          opacity: isSaving ? 0.7 : 1
        }}
      >
        <Save size={14} /> {isSaving ? 'Saving...' : 'Save Changes'}
      </button>
    </div>
  );
}
